import axios from "axios";
import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { useRouter } from "vue-router";
import { API_URL } from "@/utils/constans";

export const useRequestsStore = defineStore("request", () => {
	const router = useRouter();

	const getMasks = async () => {
		try {
			let url = `${API_URL}/api/masks/`;
			let allResults = [];

			while (url) {
				const { data } = await axios.get(url);
				allResults = [...allResults, ...data.results];
				url = data.next; // если есть следующая страница — грузим её
			}

			return allResults;
		} catch (error) {
			console.error("Ошибка получения масок", error);
			throw error;
		}
	};

	const getReviews = async (siteId = 1) => {
		try {
			let url = `${API_URL}/api/reviews/?site_id=${siteId}`;
			let allResults = [];

			while (url) {
				const { data } = await axios.get(url);
				allResults = [...allResults, ...data.results];
				url = data.next; // пока есть следующая страница — грузим её
			}

			return allResults;
		} catch (error) {
			console.error("Ошибка получения отзывов", error);
			throw error;
		}
	};

	const getPranks = async () => {
		try {
			const isProd = import.meta.env.VITE_IS_PROD === "true";

			const options = isProd
				? { params: { site_id: 1, limit: 7, offset: 0 } } // прод требует параметры
				: {}; // тестовый сервер — без params

			const { data } = await axios.get(`${API_URL}/api/reviews/social`, options);
			console.log(data);
			return data?.results;
		} catch (error) {
			console.error("Ошибка получения пранков и обзоров", error);
			throw error;
		}
	};

	const getMarqueeOne = async () => {
		try {
			const { data } = await axios.get(`${API_URL}/api/running_lines/one`);
			return data;
		} catch (error) {
			console.error("Ошибка получения бегущей строки №1", error);
			throw error;
		}
	};

	const getMarqueeTwo = async () => {
		try {
			const { data } = await axios.get(`${API_URL}/api/running_lines/two`);
			return data;
		} catch (error) {
			console.error("Ошибка получения бегущей строки №2", error);
			throw error;
		}
	};

	const getSites = async () => {
		try {
			const { data } = await axios.get(`${API_URL}/api/sites/`);
			return data;
		} catch (error) {
			console.error("Ошибка получения сайтов", error);
			throw error;
		}
	};

	const getMarketPlaces = async () => {
		try {
			const { data } = await axios.get(`${API_URL}/api/sites/market_places`, {
				params: {
					site_id: 1,
				}
			})
			return data;
		} catch (error) {
			console.error("Ошибка получения списка маркеплейсов", error);
			throw error;
		}
	};

	const getSocialNetworks = async () => {
		try {
			const { data } = await axios.get(`${API_URL}/api/sites/social_networks`, {
				params: {
					site_id: 1,
				}
			})
			return data;
		} catch (error) {
			console.error("Ошибка получения списка соц.сетей", error);
			throw error;
		}
	};

	const getPdf = async () => {
		try {
			const { data } = await axios.get(`${API_URL}/api/main/settings`, {
				params: {
					site_name: 'na_lico',
				}
			})
			return data;
		} catch (error) {
			console.error("Ошибка получения списка документов", error);
			throw error;
		}
	};

	return {
		getMasks,
		getReviews,
		getPranks,
		getMarqueeOne,
		getMarqueeTwo,
		getSites,
		getMarketPlaces,
		getSocialNetworks,
		getPdf,
	};
});
